<script>
  import { readerFontFamily } from '$lib/reader-fonts'
  import { readerOpts } from '$lib/store'

  export let href = ''
  export let title = undefined

</script>

<span style="font-family: {readerFontFamily($readerOpts.bodyFont)};"><slot></slot></span>
